import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "p-5" }
const _hoisted_2 = { class: "\n          d-flex\n          flex-wrap-reverse\n          align-items-end\n          justify-content-between\n          text-nowrap\n        " }
const _hoisted_3 = { class: "flex-column me-4" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 2,
  class: "text-muted mb-2"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_10 = { class: "mb-4" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Flyt til 'udenfor EU'")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Slet")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Opret")
const _hoisted_14 = { class: "d-flex align-items-end justify-content-between gap-3" }
const _hoisted_15 = {
  key: 0,
  class: "form-check mt-2 mb-3"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "disabledCheck"
}, " Deaktiveret ", -1)
const _hoisted_17 = {
  key: 1,
  class: "form-check mt-2 mb-3"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "adminCheck"
}, " Lokal administrator for organisationen ", -1)
const _hoisted_19 = {
  key: 2,
  class: "form-check mt-2 mb-3"
}
const _hoisted_20 = {
  class: "form-check-label",
  for: "enrollmentStatusCheck"
}
const _hoisted_21 = {
  key: 0,
  class: "flex-shrink-0 mb-3 ms-auto"
}
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-md" }
const _hoisted_24 = { class: "col-md mt-3 mt-md-0" }
const _hoisted_25 = { class: "row mt-3" }
const _hoisted_26 = { class: "col-md" }
const _hoisted_27 = {
  key: 0,
  class: "row mt-3"
}
const _hoisted_28 = { class: "col-md" }
const _hoisted_29 = {
  key: 1,
  class: "row mt-3"
}
const _hoisted_30 = { class: "col-md" }
const _hoisted_31 = {
  key: 2,
  class: "row mt-3"
}
const _hoisted_32 = { class: "col-md" }
const _hoisted_33 = {
  key: 3,
  class: "mt-3 p-3",
  style: {"background-color":"rgb(247, 249, 251)"}
}
const _hoisted_34 = { class: "d-flex mb-2 align-items-center" }
const _hoisted_35 = /*#__PURE__*/_createVNode("strong", null, "Kodeord *", -1)
const _hoisted_36 = /*#__PURE__*/_createTextVNode("Kopier til udklipsholder")
const _hoisted_37 = { class: "mt-5 p-5 bg-info flex-grow-1" }
const _hoisted_38 = {
  key: 0,
  class: "d-flex align-items-start mb-2"
}
const _hoisted_39 = /*#__PURE__*/_createVNode("h2", null, "Roller", -1)
const _hoisted_40 = { class: "ms-auto d-flex gap-2" }
const _hoisted_41 = /*#__PURE__*/_createTextVNode(" + Tilføj rolleprofil ")
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" + Tilføj rolle ")
const _hoisted_43 = { class: "d-flex flex-column" }
const _hoisted_44 = { class: "text-muted" }
const _hoisted_45 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_46 = { class: "d-flex align-items-start mb-2" }
const _hoisted_47 = /*#__PURE__*/_createVNode("h3", null, "På vegne af roller", -1)
const _hoisted_48 = { class: "ms-auto d-flex gap-2" }
const _hoisted_49 = /*#__PURE__*/_createTextVNode(" + Tilføj rolle ")
const _hoisted_50 = { class: "d-flex flex-column" }
const _hoisted_51 = { class: "text-muted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmPopup = _resolveComponent("ConfirmPopup")!
  const _component_pretty_bar = _resolveComponent("pretty-bar")!
  const _component_VDButton = _resolveComponent("VDButton")!
  const _component_o_input = _resolveComponent("o-input")!
  const _component_o_field = _resolveComponent("o-field")!
  const _component_Button = _resolveComponent("Button")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_error = _resolveComponent("error")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_RolePicker = _resolveComponent("RolePicker")!
  const _component_UserRoleProfilePicker = _resolveComponent("UserRoleProfilePicker")!
  const _component_NewSidebar = _resolveComponent("NewSidebar")!

  return (_openBlock(), _createBlock(_component_NewSidebar, {
    isLoading: _ctx.loading,
    ref: "sidebarRef",
    error: _ctx.error,
    class: "d-flex flex-column bg-white",
    onOnHiding: _ctx.handleHideSidebar
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ConfirmPopup, {
        group: "sidebar",
        appendTo: "#sidebar"
      }),
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_pretty_bar),
            (!_ctx.isNewUser)
              ? (_openBlock(), _createBlock("h2", _hoisted_4, _toDisplayString(_ctx.user?.firstname) + " " + _toDisplayString(_ctx.user?.lastname), 1))
              : (_openBlock(), _createBlock("h2", _hoisted_5, "Opret bruger")),
            (_ctx.user?.organization)
              ? (_openBlock(), _createBlock("div", _hoisted_6, [
                  _createTextVNode(_toDisplayString(_ctx.user.organization.name) + " - " + _toDisplayString(_ctx.user.organization.vat) + " ", 1),
                  _hoisted_7,
                  (!_ctx.isNewUser)
                    ? (_openBlock(), _createBlock("div", _hoisted_8, [
                        _createTextVNode(" Oprettet: " + _toDisplayString(_ctx.displayUserCreationDate(_ctx.user.creationDate, { data: _ctx.user })) + " (Seneste login: " + _toDisplayString(_ctx.totalDaysSinceLastLogin(_ctx.user.lastLogin)) + ") ", 1),
                        _hoisted_9
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_10, [
            (_ctx.canMigrateToNonEidOrganization)
              ? (_openBlock(), _createBlock(_component_VDButton, {
                  key: 0,
                  class: "me-2",
                  onClick: _ctx.migrateToNonEidOrganization,
                  isLoading: _ctx.migrateUserToNonEidOrganizationMutation.loading.value
                }, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 1
                }, 8, ["onClick", "isLoading"]))
              : _createCommentVNode("", true),
            (
              !_ctx.isNewUser &&
              _ctx.canManageUsers &&
              !_ctx.isForeignLocalAdminOnlyOfCurrentEditingUser
            )
              ? (_openBlock(), _createBlock(_component_VDButton, {
                  key: 1,
                  variant: "danger",
                  class: "me-2",
                  icon: "trash",
                  onClick: _ctx.deleteUser,
                  isLoading: _ctx.deleteUserMutation.loading.value
                }, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                }, 8, ["onClick", "isLoading"]))
              : _createCommentVNode("", true),
            (
              _ctx.isNewUser &&
              (_ctx.canManageUsers || _ctx.canAssignLocalAdminAndUpdateStatus)
            )
              ? (_openBlock(), _createBlock(_component_VDButton, {
                  key: 2,
                  icon: "check",
                  isDisabled: _ctx.v$.$error,
                  onClick: _ctx.primaryButtonPressed,
                  isLoading: 
              _ctx.updateUserMutation.loading.value ||
              _ctx.createUserMutation.loading.value
            
                }, {
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 1
                }, 8, ["isDisabled", "onClick", "isLoading"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode("form", null, [
          _createVNode("div", _hoisted_14, [
            _createVNode("div", null, [
              (!_ctx.isNewUser && !_ctx.isForeignLocalAdminOnlyOfCurrentEditingUser)
                ? (_openBlock(), _createBlock("div", _hoisted_15, [
                    _withDirectives(_createVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.user.disabled = $event)),
                      id: "disabledCheck",
                      disabled: !_ctx.canAssignLocalAdminAndUpdateStatus
                    }, null, 8, ["disabled"]), [
                      [_vModelCheckbox, _ctx.user.disabled]
                    ]),
                    _hoisted_16
                  ]))
                : _createCommentVNode("", true),
              (
                _ctx.user.organization &&
                _ctx.isNotUkendtOrganisation(_ctx.user.organization.vat) &&
                !_ctx.isForeignLocalAdminOnlyOfCurrentEditingUser
              )
                ? (_openBlock(), _createBlock("div", _hoisted_17, [
                    _withDirectives(_createVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.user.administrator = $event)),
                      id: "adminCheck",
                      disabled: !_ctx.canAssignLocalAdminAndUpdateStatus
                    }, null, 8, ["disabled"]), [
                      [_vModelCheckbox, _ctx.user.administrator]
                    ]),
                    _hoisted_18
                  ]))
                : _createCommentVNode("", true),
              (
                _ctx.userCatalogMfaEnabled &&
                !_ctx.isNewUser &&
                !_ctx.isForeignLocalAdminOnlyOfCurrentEditingUser &&
                !_ctx.user.mitID &&
                !_ctx.user.kombitID &&
                !_ctx.user.eID &&
                _ctx.user.authenticatorRegistration?.enrollmentStatus
              )
                ? (_openBlock(), _createBlock("div", _hoisted_19, [
                    _createVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      id: "enrollmentStatusCheck",
                      checked: 
                  _ctx.user.authenticatorRegistration.enrollmentStatus ===
                  _ctx.EnrollmentStatus.Enrolled
                ,
                      disabled: ""
                    }, null, 8, ["checked"]),
                    _createVNode("label", _hoisted_20, _toDisplayString(_ctx.$translate("TextResources_EnrollmentStatus")) + " (" + _toDisplayString(_ctx.$translate(
                    "TextResources_EnrollmentStatus_" +
                      _ctx.user.authenticatorRegistration.enrollmentStatus
                  )) + ") ", 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            (
              _ctx.canResetAuthenticator &&
              !_ctx.user.mitID &&
              !_ctx.user.kombitID &&
              !_ctx.user.eID
            )
              ? (_openBlock(), _createBlock("div", _hoisted_21, [
                  _createVNode(_component_VDButton, {
                    type: "button",
                    style: {"background-color":"#a0a0a0","border-color":"#a0a0a0","color":"#fff"},
                    isLoading: _ctx.isResettingAuthenticator,
                    isDisabled: _ctx.loading,
                    onClick: _ctx.resetAuthenticatorRegistration
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$translate("TextResources_ResetTwoFactor")), 1)
                    ]),
                    _: 1
                  }, 8, ["isLoading", "isDisabled", "onClick"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_22, [
            _createVNode("div", _hoisted_23, [
              _createVNode(_component_o_field, {
                variant: _ctx.v$.firstname.$error ? 'danger' : '',
                label: "Fornavn *"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_o_input, {
                    ref: "firstnameInput",
                    modelValue: _ctx.user.firstname,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.user.firstname = $event)),
                    disabled: !_ctx.isNewUser || !_ctx.canManageUsers
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }, 8, ["variant"])
            ]),
            _createVNode("div", _hoisted_24, [
              _createVNode(_component_o_field, {
                variant: _ctx.v$.lastname.$error ? 'danger' : '',
                label: "Efternavn *"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_o_input, {
                    modelValue: _ctx.user.lastname,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.user.lastname = $event)),
                    disabled: !_ctx.isNewUser || !_ctx.canManageUsers
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }, 8, ["variant"])
            ])
          ]),
          _createVNode("div", _hoisted_25, [
            _createVNode("div", _hoisted_26, [
              _createVNode(_component_o_field, {
                variant: _ctx.v$.email.$error ? 'danger' : '',
                label: "Brugernavn (e-mail) *"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_o_input, {
                    disabled: !_ctx.isNewUser || !_ctx.canManageUsers,
                    modelValue: _ctx.user.email,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.user.email = $event))
                  }, null, 8, ["disabled", "modelValue"])
                ]),
                _: 1
              }, 8, ["variant"])
            ])
          ]),
          (!_ctx.isForeignLocalAdminOnlyOfCurrentEditingUser)
            ? (_openBlock(), _createBlock("div", _hoisted_27, [
                _createVNode("div", _hoisted_28, [
                  _createVNode(_component_o_field, { label: "MitID" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_o_input, {
                        modelValue: _ctx.user.mitID,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.user.mitID = $event)),
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isForeignLocalAdminOnlyOfCurrentEditingUser)
            ? (_openBlock(), _createBlock("div", _hoisted_29, [
                _createVNode("div", _hoisted_30, [
                  _createVNode(_component_o_field, { label: "KombitID" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_o_input, {
                        modelValue: _ctx.user.kombitID,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.user.kombitID = $event)),
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isForeignLocalAdminOnlyOfCurrentEditingUser)
            ? (_openBlock(), _createBlock("div", _hoisted_31, [
                _createVNode("div", _hoisted_32, [
                  _createVNode(_component_o_field, { label: "eID" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_o_input, {
                        modelValue: _ctx.user.eID,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.user.eID = $event)),
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isNewUser)
            ? (_openBlock(), _createBlock("div", _hoisted_33, [
                _createVNode("div", _hoisted_34, [
                  _hoisted_35,
                  _createVNode(_component_Button, {
                    onClick: _ctx.copyPasswordToClipboard,
                    class: "ms-auto secondary inverted"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_36
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _createVNode(_component_o_field, {
                  variant: _ctx.v$.password.$error ? 'danger' : ''
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_o_input, {
                      modelValue: _ctx.password,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.password = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["variant"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode("div", _hoisted_37, [
        (!_ctx.isForeignLocalAdminOnlyOfCurrentEditingUser)
          ? (_openBlock(), _createBlock("div", _hoisted_38, [
              _hoisted_39,
              _createVNode("div", _hoisted_40, [
                (
              _ctx.user.organization &&
              _ctx.isNotUkendtOrganisation(_ctx.user.organization.vat)
            )
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      disabled: _ctx.addRemoveLoading,
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.userRoleProfilePicker?.toggle($event))),
                      class: "secondary"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.addRemoveLoading)
                          ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                              key: 0,
                              class: "me-2",
                              spin: "",
                              icon: ['fas', 'spinner']
                            }))
                          : _createCommentVNode("", true),
                        _hoisted_41
                      ]),
                      _: 1
                    }, 8, ["disabled"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_Button, {
                  disabled: _ctx.addRemoveLoading,
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.rolePicker?.toggle($event))),
                  class: "secondary"
                }, {
                  default: _withCtx(() => [
                    (_ctx.addRemoveLoading)
                      ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                          key: 0,
                          class: "me-2",
                          spin: "",
                          icon: ['fas', 'spinner']
                        }))
                      : _createCommentVNode("", true),
                    _hoisted_42
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.isForeignLocalAdminOnlyOfCurrentEditingUser)
          ? (_openBlock(), _createBlock(_component_DataTable, {
              key: 1,
              stripedRows: true,
              sortOrder: 1,
              responsiveLayout: "scroll",
              value: _ctx.userRoles,
              class: "text-start",
              selectionMode: "single"
            }, {
              empty: _withCtx(() => [
                _createVNode(_component_error, { error: {
              title: 'Ingen roller',
              message: 'Der er ikke nogle roller tilknyttet denne bruger endnu',
            } })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  field: "name",
                  sortable: true
                }, {
                  body: _withCtx(({ data }) => [
                    _createVNode("div", _hoisted_43, [
                      _createVNode("small", _hoisted_44, _toDisplayString(data.organizationName) + " - " + _toDisplayString(data.applicationName), 1),
                      _createTextVNode(" " + _toDisplayString(data.roleName), 1)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  style: {"width":"1px","white-space":"nowrap"},
                  field: "menu"
                }, {
                  body: _withCtx(({ data }) => [
                    _createVNode(_component_Button, {
                      class: "danger inverted",
                      onClick: ($event: any) => (_ctx.onRemovedRole(data))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, { icon: ['fas', 'minus'] })
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"]))
          : _createCommentVNode("", true),
        _hoisted_45,
        _createVNode("div", _hoisted_46, [
          _hoisted_47,
          _createVNode("div", _hoisted_48, [
            (_ctx.isForeignLocalAdminOnlyOfCurrentEditingUser)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  disabled: _ctx.addRemoveLoading,
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.rolePicker?.toggle($event))),
                  class: "secondary"
                }, {
                  default: _withCtx(() => [
                    (_ctx.addRemoveLoading)
                      ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                          key: 0,
                          class: "me-2",
                          spin: "",
                          icon: ['fas', 'spinner']
                        }))
                      : _createCommentVNode("", true),
                    _hoisted_49
                  ]),
                  _: 1
                }, 8, ["disabled"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode(_component_DataTable, {
          stripedRows: true,
          sortOrder: 1,
          responsiveLayout: "scroll",
          value: _ctx.onBehalfOfRoles,
          class: "text-start",
          selectionMode: "single"
        }, {
          empty: _withCtx(() => [
            _createVNode(_component_error, { error: {
              title: 'Ingen på vegne af roller',
              message:
                'Der er ikke nogle på vegne af roller tilknyttet denne bruger endnu',
            } })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              field: "name",
              sortable: true
            }, {
              body: _withCtx(({ data }) => [
                _createVNode("div", _hoisted_50, [
                  _createVNode("small", _hoisted_51, _toDisplayString(data.organizationName) + " - " + _toDisplayString(data.applicationName), 1),
                  _createTextVNode(" " + _toDisplayString(data.roleName), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              style: {"width":"1px","white-space":"nowrap"},
              field: "menu"
            }, {
              body: _withCtx(({ data }) => [
                _createVNode(_component_Button, {
                  class: "danger inverted",
                  onClick: ($event: any) => (_ctx.onRemovedRole(data))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'minus'] })
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"])
      ]),
      _createVNode(_component_RolePicker, {
        disabled: _ctx.addRemoveLoading,
        ref: "rolePicker",
        userId: _ctx.id,
        organizationId: _ctx.organizationId,
        addedRoles: _ctx.user.roles as _ctx.RoleAssigneeType[] ?? [],
        onAddedRole: _ctx.onAddedRole
      }, null, 8, ["disabled", "userId", "organizationId", "addedRoles", "onAddedRole"]),
      (_ctx.canUseRoleProfiles)
        ? (_openBlock(), _createBlock(_component_UserRoleProfilePicker, {
            key: 0,
            ref: "userRoleProfilePicker",
            disabled: _ctx.addRemoveLoading,
            organizationId: _ctx.roleProfileOrganizationId,
            onProfilesSelected: _ctx.onProfilesSelected
          }, null, 8, ["disabled", "organizationId", "onProfilesSelected"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["isLoading", "error", "onOnHiding"]))
}